'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Videocam = require('material-ui-icons/Videocam');

var _Videocam2 = _interopRequireDefault(_Videocam);

var _CallInfo = require('../CallInfo');

var _CallInfo2 = _interopRequireDefault(_CallInfo);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import VideoCamIcon from "icons/OutlineVideocam";
// import RequestCallButton from "ui/Button/User/RequestCall";


var styles = {};

var CallButton = function (_Component) {
  _inherits(CallButton, _Component);

  function CallButton() {
    var _temp, _this, _ret;

    _classCallCheck(this, CallButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      callInfoOpened: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CallButton.prototype.toggleCallInfo = function toggleCallInfo() {
    var callInfoOpened = this.state.callInfoOpened;
    this.setState({
      callInfoOpened: !callInfoOpened
    });
  };

  CallButton.prototype.render = function render() {
    var _this2 = this;

    var callButton = null;
    var _props = this.props,
        room = _props.room,
        currentUser = _props.currentUser,
        classes = _props.classes;

    if (!room || !currentUser) {
      return null;
    }

    var callInfoOpened = this.state.callInfoOpened;
    var roomId = room.id,
        Call = room.Call,
        members = room.Members;
    var currentUserId = currentUser.id; // if (Call) {
    //   const {
    //     status,
    //   } = Call;
    //   if (["Accepted"].indexOf(status) !== -1) {
    //     callButton = <button
    //       className="videoButton button bg-green"
    //       onClick={showVideoChatHandler}
    //     >
    //       <VideoCamIcon
    //       // style={{
    //       //   fill: "transparent",
    //       //   stroke: "#fff",
    //       // }}
    //       /> Show video chat
    //     </button>;
    //   }
    // }

    var showCallInfo = callInfoOpened;
    var called = null;
    /**
     * Если звонок есть, то вызываемого берем из этого звонка.
     * Иначе вызываемый - случайный пользователь из текущей сессии
     */

    if (Call) {
      /**
       * Если звонок требует ответного действия
       * от того, кому звонят, надо вывести форму
       */
      var status = Call.status,
          calledId = Call.User.id;

      if (status === "Requested" && calledId === currentUserId) {
        showCallInfo = true;
      }

      called = members ? members.find(function (_ref) {
        var id = _ref.id;
        return id === calledId;
      }) : null;
    } else {
      called = members ? members.filter(function (_ref2) {
        var id = _ref2.id;
        return id !== currentUserId;
      }).find(function (n) {
        return n.callsEnabled === true;
      }) : null;
    }

    if (!callButton) {
      /**
       * Запрашиваем звонок только если у кого-то из пользователей разрешены входящие звонки
       */
      // if (called) {
      if (called) {
        callButton = _react2.default.createElement('button', {
          className: 'videoButton button bg-blue',
          onClick: function onClick(event) {
            _this2.toggleCallInfo();
          }
        }, _react2.default.createElement(_Videocam2.default // style={{
        //   fill: "transparent",
        //   stroke: "#fff",
        // }}
        , null), ' ', !Call ? "Request a video call" : "Show call info");
      } // callButton = <button
      //   className="videoButton button bg-blue"
      // >
      //   <VideoCamIcon
      //   // style={{
      //   //   fill: "transparent",
      //   //   stroke: "#fff",
      //   // }}
      //   /> Request a video call
      // </button>;
      // callButton = <RequestCallButton
      //   room={room}
      //   user={called}
      // >
      //   <button
      //     className="videoButton button bg-blue"
      //   >
      //     <VideoCamIcon
      //     // style={{
      //     //   fill: "transparent",
      //     //   stroke: "#fff",
      //     // }}
      //     /> Request a video call
      //   </button>
      // </RequestCallButton>
      // ;

    } // }


    return _react2.default.createElement('div', null, callButton, showCallInfo ? _react2.default.createElement(_CallInfo2.default, {
      user: called,
      room: room
    }) : null);
  };

  return CallButton;
}(_react.Component);

CallButton.propTypes = process.env.NODE_ENV !== "production" ? {
  room: _propTypes2.default.object,
  currentUser: _propTypes2.default.object.isRequired // showVideoChatHandler: PropTypes.func.isRequired,

} : {};
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(CallButton, props);
});
module.exports = exports['default'];